/* eslint-disable no-param-reassign */

import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/en';
import '@formatjs/intl-relativetimeformat/locale-data/de';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/de';

import { DEFAULT_LOCALE } from './containers/App/constants/language';

export const appLocales = ['en', 'de'];

const formatTranslationMessages = (locale, messages, defaultMessages = {}) =>
  Object.keys(messages).reduce((formatted, key) => {
    let message = messages[key];
    if (!message && locale !== DEFAULT_LOCALE) {
      message = defaultMessages[key];
    }
    formatted[key] = message;
    return formatted;
  }, {});

const loadAllLocales = async () => {
  const enPromise = import('./translations/en.json');
  const dePromise = import('./translations/de.json');

  const [enModule, deModule] = await Promise.all([enPromise, dePromise]);

  const defaultMessages = enModule.default;

  return {
    en: formatTranslationMessages('en', enModule.default, defaultMessages),
    de: formatTranslationMessages('de', deModule.default, defaultMessages),
  };
};

export const translationMessages = loadAllLocales;
